var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[(_vm.isLoading)?_c('div',{staticClass:"flex text-gray-500 my-24 md:my-56 justify-center"},[_c('span',[_vm._v("\n      "+_vm._s(_vm.$t('appLoading'))+"\n      "),_c('BouncingDots',{staticClass:"ml-1 text-xl"})],1)]):_c('router-view'),_vm._v(" "),_c('NotificationCenter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }